import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useCreatePaymentIntegrationMutation } from "store/services/paymentIntegrationApi";

import { useAppMeta } from "hooks";
import PaymentIntegrationForm from "./PaymentIntegrationComponent/PaymentIntegrationForm";

const PaymentIntegrationCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Payment Integrations", path: "/app/crm/paymentIntegration/list" },
    { title: "New Payment Integration" },
  ];

  // RTK Query
  const [createPaymentIntegration, { isLoading: creatingPaymentIntegration }] =
    useCreatePaymentIntegrationMutation();

  // methods
  const handleAddPaymentIntegration = async (data) => {
    try {
      await createPaymentIntegration(data).unwrap();
      toast.success("Payment Integration successfully created!");
      navigate(breadcrumbs[0]?.path);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add payment integration!");
    }
  };

  useAppMeta("New Payment Integration");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingPaymentIntegration}>
      <BreadcrumbLayout.Paper>
        <PaymentIntegrationForm
          isBusy={creatingPaymentIntegration}
          onSubmit={handleAddPaymentIntegration}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentIntegrationCreateScreen;